<script setup>
import {Dialog, DialogDescription, DialogPanel, DialogTitle, TransitionRoot} from "@headlessui/vue";

const props = defineProps({
    type: String,
    title: String,
    message: String,
    isOpen: Boolean,
});

</script>
<template>
    <TransitionRoot
        :show="props.isOpen"
        as="template"
        enter="duration-100 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-100 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
    >
        <Dialog @close="$emit('close')" class="z-50">
            <div class="fixed inset-0 bg-black/30" aria-hidden="true" />
            <DialogPanel class="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[90%] max-w-lg bg-white dark:bg-bg-dark rounded-2xl shadow-lg py-10 px-12 text-center">
                <button type="button"
                        @click="$emit('close')"
                        class="absolute top-5 right-5 w-8 h-8 flex items-center justify-center hover:text-orange outline-none shadow-none"
                        tabindex="0"><span class="sr-only">Закрыть диалоговое окно</span>
                    <svg viewBox="0 0 10 10" class="w-3 h-3 overflow-visible" aria-hidden="true">
                        <path d="M0 0L10 10M10 0L0 10" fill="none" stroke="currentColor" stroke-width="2"
                              stroke-linecap="round"></path>
                    </svg>
                </button>
                <div v-if="props.type === 'success'" class="pt-2 pb-8">
                    <img class="inline-block max-w-[160px]" src="/images/dialog-dice-success.png" alt="">
                </div>
                <div v-if="props.type === 'error'" class="pt-2 pb-8">
                    <img class="inline-block max-w-[160px]" src="/images/dialog-dice-fail.png" alt="">
                </div>
                <DialogTitle v-html="props.title" class="text-3xl lg:text-[2.5rem] font-bold leading-none tracking-tighter text-black dark:text-white"/>
                <DialogDescription v-html="props.message" class="mt-8"/>
            </DialogPanel>
        </Dialog>
    </TransitionRoot>
</template>
